<template>
  <div class="table-content">
    <div class="search">
      <slot name='from'></slot>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%" height="100%"
        header-cell-class-name='table-header-cell' cell-class-name='table-cell'
        border stripe fit  highlight-current-row v-loading='loading'
        @row-click='handleRowClick' >
        <el-table-column
          v-for="column in columns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          header-align="center"
          :align="column.align?column.align:'center'"
          :min-width="column.minWidth"
          :formatter="column.formatter" 
          show-overflow-tooltip
        >
        </el-table-column>
        <slot name="column"></slot>
        <el-table-column fixed="right" label="操作" :min-width="optionWidth" align="center">
          <template slot-scope="scope">
            <slot name="option" :scope='{...scope}'></slot>
            <!-- 修改 -->
            <el-button v-if="editIsNeed" @click.native.prevent="handleEdit(scope.$index, scope.row)" type="text" :size="size" >修改</el-button>
            <!-- 删除 -->
            <el-button v-if="deleteIsNeed" @click.native.prevent="handleDelete(scope.$index, scope.row)" type="text" :size="size" >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: Array,
    tableData: Array,
    editIsNeed: {
      type: Boolean,
      default: true
    },
    deleteIsNeed: {
      type: Boolean,
      default: true
    },
    optionWidth: {
      type: String,
      default: '120'
    },
    loading: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handleRowClick (row, column) {
      this.$emit('handleRowClick', { row, column })
    },
    handleEdit (index, row) {
      this.$emit('handleEdit', { index, row })
    },
    handleDelete (index, row) {
      this.$emit('handleDelete', { index, row })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-content {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}
.table {
  height: calc(100% - 60px);
}
</style>
